export const uaLimitedReleasesListConstants = {
  UA_LIMITED_RELEASES_LIST_LOADING: "UA_LIMITED_RELEASES_LIST_LOADING",
  UA_LIMITED_RELEASES_LIST_SUCCESS: "UA_LIMITED_RELEASES_LIST_SUCCESS",
  UA_LIMITED_RELEASES_LIST_FAILURE: "UA_LIMITED_RELEASES_LIST_FAILURE",
};
